import * as type from './actionTypes';
import * as types from './types';

export const dataCutOff = (payload: types.DataCutOffRequestPayload): types.DataCutOffRequest => ({
    type: type.DATA_CUTOFF,
    payload,
});

export const dataCutOffSuccess = (payload: types.DataCutOffSuccessPayload): types.DataCutOffSuccess => ({
    type: type.DATA_CUTOFF_SUCCESS,
    payload,
});

export const dataCutOffFailure = (payload: types.DataCutOffFailurePayload): types.DataCutOffFailure => ({
    type: type.DATA_CUTOFF_FAILURE,
    payload,
});

export const topUp = (payload: types.TopUpRequestPayload): types.TopUpRequest => ({
    type: type.TOP_UP,
    payload,
});

export const topUpSuccess = (payload: types.TopUpSuccessPayload): types.TopUpSuccess => ({
    type: type.TOP_UP_SUCCESS,
    payload,
});

export const topUpFailure = (payload: types.TopUpFailurePayload): types.TopUpFailure => ({
    type: type.TOP_UP_FAILURE,
    payload,
});

export const topUpPulse = (): types.TopUpPulseRequest => ({
    type: type.TOP_UP_PULSE,
});

export const topUpPulseSuccess = (payload: types.TopUpPulseSuccessPayload): types.TopUpPulseSuccess => ({
    type: type.TOP_UP_PULSE_SUCCESS,
    payload,
});

export const topUpPulseFailure = (payload: types.TopUpPulseFailurePayload): types.TopUpPulseFailure => ({
    type: type.TOP_UP_PULSE_FAILURE,
    payload,
});

export const customerGroup = (payload: types.CustomerGroupRequestPayload): types.CustomerGroupRequest => ({
    type: type.GROUPS,
    payload,
});

export const customerGroupSuccess = (payload: types.CustomerGroupSuccessPayload): types.CustomerGroupSuccess => ({
    type: type.GROUPS_SUCCESS,
    payload,
});

export const customerGroupFailure = (payload: types.CustomerGroupFailurePayload): types.CustomerGroupFailure => ({
    type: type.GROUPS_FAILURE,
    payload,
});

//Activation Precheck
export const activationPrecheck = (
    payload: types.ActivationPrecheckRequestPayload,
): types.ActivationPrecheckRequest => ({
    type: type.ACTIVATION_PRECHECK,
    payload,
});

export const activationPrecheckSuccess = (
    payload: types.ActivationPrecheckSuccessPayload,
): types.ActivationPrecheckSuccess => ({
    type: type.ACTIVATION_PRECHECK_SUCCESS,
    payload,
});

export const activationPrecheckFailure = (
    payload: types.ActivationPrecheckFailurePayload,
): types.ActivationPrecheckFailure => ({
    type: type.ACTIVATION_PRECHECK_FAILURE,
    payload,
});

export const topUpGroup = (payload: types.TopUpGroupRequestPayload): types.TopUpGroupRequest => ({
    type: type.TOP_UP_GROUPS,
    payload,
});

export const topUpGroupSuccess = (payload: types.TopUpGroupSuccessPayload): types.TopUpGroupSuccess => ({
    type: type.TOP_UP_GROUPS_SUCCESS,
    payload,
});

export const topUpGroupFailure = (payload: types.TopUpGroupFailurePayload): types.TopUpGroupFailure => ({
    type: type.TOP_UP_GROUPS_FAILURE,
    payload,
});

export const getCredit = (payload: types.GetCreditRequestPayload): types.GetCreditRequest => ({
    type: type.GET_CREDIT,
    payload,
});

export const getCreditSuccess = (payload: types.GetCreditSuccessPayload): types.GetCreditSuccess => ({
    type: type.GET_CREDIT_SUCCESS,
    payload,
});

export const getCreditFailure = (payload: types.GetCreditFailurePayload): types.GetCreditFailure => ({
    type: type.GET_CREDIT_FAILURE,
    payload,
});

export const type4Tax = (payload: types.Type4TaxRequestPayload): types.Type4TaxRequest => ({
    type: type.TAX_4_TYPE,
    payload,
});

export const type4TaxSuccess = (payload: types.Type4TaxSuccessPayload): types.Type4TaxSuccess => ({
    type: type.TAX_4_TYPE_SUCCESS,
    payload,
});

export const type4TaxFailure = (payload: types.Type4TaxFailurePayload): types.Type4TaxFailure => ({
    type: type.TAX_4_TYPE_FAILURE,
    payload,
});

export const topUpCustomer = (payload: types.TopUpCustomerRequestPayload): types.TopUpCustomerRequest => ({
    type: type.TOP_UP_CUSTOMER,
    payload,
});

export const topUpCustomerSuccess = (payload: types.TopUpCustomerSuccessPayload): types.TopUpCustomerSuccess => ({
    type: type.TOP_UP_CUSTOMER_SUCCESS,
    payload,
});

export const topUpCustomerFailure = (payload: types.TopUpCustomerFailurePayload): types.TopUpCustomerFailure => ({
    type: type.TOP_UP_CUSTOMER_FAILURE,
    payload,
});

// top up customer status
export const topUpCustomerStatus = (
    payload: types.TopUpCustomerStatusRequestPayload,
): types.TopUpCustomerStatusRequest => ({
    type: type.TOP_UP_CUSTOMER_STATUS,
    payload,
});

export const topUpCustomerStatusSuccess = (
    payload: types.TopUpCustomerStatusSuccessPayload,
): types.TopUpCustomerStatusSuccess => ({
    type: type.TOP_UP_CUSTOMER_STATUS_SUCCESS,
    payload,
});

export const topUpCustomerStatusFailure = (
    payload: types.TopUpCustomerStatusFailurePayload,
): types.TopUpCustomerStatusFailure => ({
    type: type.TOP_UP_CUSTOMER_STATUS_FAILURE,
    payload,
});

// buy data customer status
export const planChangeCustomerStatus = (
    payload: types.PlanChangeCustomerStatusRequestPayload,
): types.PlanChangeCustomerStatusRequest => ({
    type: type.PLAN_CHANGE_CUSTOMER_STATUS,
    payload,
});

export const planChangeCustomerStatusSuccess = (
    payload: types.PlanChangeCustomerStatusSuccessPayload,
): types.PlanChangeCustomerStatusSuccess => ({
    type: type.PLAN_CHANGE_CUSTOMER_STATUS_SUCCESS,
    payload,
});

export const planChangeCustomerStatusFailure = (
    payload: types.PlanChangeCustomerStatusFailurePayload,
): types.PlanChangeCustomerStatusFailure => ({
    type: type.PLAN_CHANGE_CUSTOMER_STATUS_FAILURE,
    payload,
});

export const referalCredit = () => ({
    type: type.REFERAL_CREDIT,
});

export const referalCreditSuccess = (payload: types.ReferalCreditSuccessPayload): types.ReferalCreditSuccess => ({
    type: type.REFERAL_CREDIT_SUCCESS,
    payload,
});

export const referalCreditFailure = (payload: types.ReferalCreditFailurePayload): types.ReferalCreditFailure => ({
    type: type.REFERAL_CREDIT_FAILURE,
    payload,
});

export const changePlan = (payload: types.ChangePlanRequestPayload): types.ChangePlanRequest => ({
    type: type.CHANGE_PLAN,
    payload,
});

export const changePlanSuccess = (payload: types.ChangePlanSuccessPayload): types.ChangePlanSuccess => ({
    type: type.CHANGE_PLAN_SUCCESS,
    payload,
});

export const changePlanFailure = (payload: types.ChangePlanFailurePayload): types.ChangePlanFailure => ({
    type: type.CHANGE_PLAN_FAILURE,
    payload,
});

export const otp = (payload: types.OtpRequestPayload): types.OtpRequest => ({
    type: type.OTP,
    payload,
});

export const otpSuccess = (payload: types.OtpSuccessPayload): types.OtpSuccess => ({
    type: type.OTP_SUCCESS,
    payload,
});

export const otpFailure = (payload: types.OtpFailurePayload): types.OtpFailure => ({
    type: type.OTP_FAILURE,
    payload,
});

export const accStatus = (payload: types.AccStatusRequestPayload): types.AccStatusRequest => ({
    type: type.ACC_STATUS,
    payload,
});

export const accStatusSuccess = (payload: types.AccStatusSuccessPayload): types.AccStatusSuccess => ({
    type: type.ACC_STATUS_SUCCESS,
    payload,
});

export const accStatusFailure = (payload: types.AccStatusFailurePayload): types.AccStatusFailure => ({
    type: type.ACC_STATUS_FAILURE,
    payload,
});

export const settingsPageReset = (payload: any) => ({
    type: type.CLEAR_FCC_RESET,
    payload,
});
